// src/components/SignUp.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { BASE_URI } from '../Config';
import { useNotifications } from '../NotificationContext';


const SignUp: React.FC = () => {
    const navigate = useNavigate(); // Initialize the hook
    const location = useLocation();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password_repeat, setPasswordRepeat] = useState("");
    const [institution, setInstitution] = useState("");
    const { pushMessage } = useNotifications();
    const signupSource =
        new URLSearchParams(location.search).get("signup_source") === "mhcattention"
            ? "mhcattention"
            : "tapir";


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        // For now, we'll just log the user data. You can add API calls or other logic here later.
        console.log({ name, email, password, institution });

        const userData = {new_user: { name, email, password, institution, signup_source: signupSource }};

        if (password !== password_repeat){
            pushMessage({text:"Passwords do not match", type: "error"})
            return;
        }

        try {
            const response = await fetch(`${BASE_URI}/users/signup`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData)
            });

            const data = await response.json();

            if (data.success) {
                console.log("Signup successful!");
                pushMessage({text:"Signed up! Please check your email to verify your account.", type: "notification"});
                navigate("/signin") // This will probably be email verifcation page??
                // Redirect or perform other actions after successful signup
            } else {
                pushMessage({text: "Problem creating account, please ensure fields are not blank", type: "error"});
                console.log("Signup failed!");
            }
        } catch (error) {
            console.error("There was an error during signup:", error);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3>Sign Up</h3>
            <div>
                <label>Name: </label>
                <input type="text" value={name} onChange={e => setName(e.target.value)} />
            </div>
            <div>
                <label>Email: </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder='Please provide institutional email' />
            </div>
            <div>
                <label>Password: </label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder='Password' />
                <input type="password" value={password_repeat} onChange={e => setPasswordRepeat(e.target.value)} placeholder='Repeat password' />
            </div>
            <div>
                <label>Institution: </label>
                <input type="text" value={institution} onChange={e => setInstitution(e.target.value)} />
            </div>
            <div className="TC">
                <input type="checkbox" id="terms" name="terms" required />
                <label htmlFor="terms">I have read and agree to Vcreate's <a href="/vcreate-tapir-tos.pdf" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and <a href="/privacy-policy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</label>
            </div>
            <input type="submit" value="Submit"></input>
        </form>
    );
}

export default SignUp;
